import { Annotation, AnnotationCategory } from './MarkedPeriodsDetails'

interface MarkedPeriodChartData {
	values: { data: number[] }[]
}

export const useMarkedPeriods = (resolution: 'hour' | 'quarter' = 'hour') => {
	const getAnnotations = (chartData: MarkedPeriodChartData, show = false, isDarkMode = false) => {
		if (!show) return []

		const values = chartData?.values[0]?.data ?? []

		// Sort and calculate dynamic percentiles
		const sorted = [...values].sort((a, b) => a - b)
		const getPercentile = (arr: number[], percentile: number) => {
			const index = Math.floor(percentile * arr.length)
			return arr[index]
		}

		const lowThreshold = getPercentile(sorted, 0.25)
		const highThreshold = getPercentile(sorted, 0.75)

		const getCategory = (value: number): AnnotationCategory => {
			if (value <= lowThreshold) return 'low'
			if (value >= highThreshold) return 'high'
			return 'mid'
		}

		// Create annotations for each cheap/expensive hour
		// Group consecutive indices by category
		const annotations: Annotation[] = []
		let runStart = 0
		let currentCategory = getCategory(values[0])

		for (let i = 1; i <= values.length; i++) {
			// Check if category changes or we reached the end of values
			const cat = i < values.length ? getCategory(values[i]) : 'mid'
			if (cat !== currentCategory) {
				const runLength = i - runStart
				if (resolution === 'quarter' ? runLength >= 8 : runLength >= 2) {
					// Create one annotation covering the whole run
					let backgroundColor = 'rgba(0, 0, 0, 0)' // default yellow for mid
					if (currentCategory === 'low')
						backgroundColor = isDarkMode ? 'rgba(0, 200, 0, 0.55)' : 'rgba(0, 200, 0, 0.45)'
					else if (currentCategory === 'high')
						backgroundColor = isDarkMode ? 'rgba(255, 0, 0, 0.55)' : 'rgba(255, 0, 0, 0.45)'

					annotations.push({
						type: 'box',
						xMin: runStart - 0.5,
						xMax: i - 1 + 0.5,
						backgroundColor,
						borderWidth: 0,
						drawTime: 'beforeDatasetsDraw',
						category: currentCategory,
					})
				} else {
					annotations.push({
						type: 'box',
						xMin: runStart - 0.5,
						xMax: i - 1 + 0.5,
						backgroundColor: 'rgba(0, 0, 0, 0)',
						borderWidth: 0,
						drawTime: 'beforeDatasetsDraw',
						category: 'mid',
					})
				}
				// Start new run
				runStart = i
				currentCategory = cat
			}
		}

		return annotations
	}

	return getAnnotations
}
